<!--
  购买引导组件
  1. 全局弹层模式（默认）：由 store.miniGuideShow 控制，store.guideType 决定引导类型
     - 'mini'：引导打开一席小程序（现场购票、万象/文章购买等）
     - 'app'：引导下载一席App（需要账号、支付等小程序不支持的操作）
  2. 内嵌模式（inline）：直接嵌入页面，用于报名页、付费阅读页等整页引导
-->
<template>
  <div v-if="!inline && show" class="mini-guide-overlay" @click.self="close">
    <div class="mini-guide-card">
      <i class="iconfont iconclose mini-guide-close" @click="close"></i>
      <img class="mini-guide-qr" :src="qrImg" :alt="overlayType === 'app' ? '一席App下载二维码' : '一席小程序二维码'" />
      <div class="mini-guide-title">
        <img v-if="overlayType === 'app'" class="mini-guide-logo" src="@/assets/imgs/app/yixi_logo_512.png" alt="一席" />
        {{ overlayType === 'app' ? '「一席」App' : '「一席」微信小程序' }}
      </div>
      <p class="mini-guide-desc">{{ overlayType === 'app' ? '扫码下载并安装「一席」App，\n即可观看完整视频。' : '微信扫一扫，打开「一席」小程序' }}</p>
    </div>
  </div>
  <div v-else-if="inline" class="mini-guide-card mini-guide-standalone">
    <img class="mini-guide-qr" :src="qrImg" :alt="type === 'app' ? '一席App下载二维码' : '一席小程序二维码'" />
    <div class="mini-guide-title">
      <img v-if="type === 'app'" class="mini-guide-logo" src="@/assets/imgs/app/yixi_logo_512.png" alt="一席" />
      {{ type === 'app' ? '「一席」App' : '「一席」微信小程序' }}
    </div>
    <p class="mini-guide-desc">{{ type === 'app' ? '扫码下载并安装「一席」App，\n即可观看完整视频。' : '微信扫一扫，打开「一席」小程序' }}</p>
  </div>
</template>

<script>
export default {
  name: 'MiniProgramGuide',
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'mini', // 'mini' 小程序引导 | 'app' App下载引导
    },
  },
  computed: {
    show() {
      return this.$store.state.miniGuideShow;
    },
    overlayType() {
      return this.$store.state.guideType || 'mini';
    },
    qrImg() {
      const t = this.inline ? this.type : this.overlayType;
      return t === 'app'
        ? require('@/assets/imgs/qrcode/appDownload.png')
        : require('@/assets/imgs/yixi_mini.png');
    },
  },
  methods: {
    close() {
      this.$store.commit('setMiniGuideShow', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.mini-guide-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 3001;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mini-guide-card {
  position: relative;
  background: #fff;
  border-radius: 8px;
  padding: 24px 48px 20px;
  width: 360px;
  box-sizing: border-box;
  text-align: center;
}
.mini-guide-close {
  position: absolute;
  top: 14px;
  right: 16px;
  font-size: 18px;
  color: #999;
  cursor: pointer;
  &:hover {
    color: #333;
  }
}
.mini-guide-qr {
  width: 240px;
  height: 240px;
  display: block;
  margin: 0 auto;
}
.mini-guide-title {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-top: 16px;
}
.mini-guide-logo {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  margin-right: 10px;
}
.mini-guide-desc {
  font-size: 13px;
  line-height: 1.8;
  color: #888;
  margin-top: 10px;
  white-space: pre-line;
}
.mini-guide-standalone {
  margin: 60px auto;
}
</style>
